import flow from 'lodash/flow';

export const getManagedState = ({ managed }) => managed;
export const getManagedSoundcast = flow(
  getManagedState,
  ({ soundcasts }) => soundcasts
);

export const getManagedSoundcastsStatus = flow(
  getManagedState,
  ({ ready }) => ready
);

export const getManagedSoundcastById = flow(
  getManagedState,
  ({ soundcasts }) => soundcasts.byId
);

export const getManagedEpisodes = flow(
  getManagedState,
  ({ episodes }) => episodes
);

export const getManagedEpisodesById = flow(
  getManagedEpisodes,
  ({ byId }) => byId
);

export const getManagedEpisodesBySoundcast = flow(
  getManagedEpisodes,
  ({ bySoundcast }) => bySoundcast
);
